<template>
  <Section
    decoration="/images/flow.svg"
    :title="t('sections.hero')"
    id="hero"
    hero
  >
    <p class="hero__subtitle">
      {{ t('hero.headline') }}
    </p>

    <h1 class="hero__title">
      Lívia<br>Almeida
    </h1>

    <p class="hero__description">
      {{ t('hero.description') }}
    </p>

    <nav>
      <ul class="hero__nav">
        <li
          v-for="item in pagemap"
          :key="item.title"
          class="hero__navitem"
        >
          <a
            :href="item.url"
            class="hero__link"
            @click="onNavigation"
          >
            {{ t(item.title) }}
          </a>
        </li>
      </ul>
    </nav>
  </Section>
</template>

<script lang="ts" setup>
import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core';
import { useI18n } from 'vue-i18n';

import Section from '@/ui/Section.vue';

const { t } = useI18n();

const pagemap = [
  { title: 'sections.about', url: '#about' },
  { title: 'sections.experience', url: '#experience' },
  { title: 'sections.education', url: '#education' },
  { title: 'sections.skills', url: '#skills' },
  { title: 'sections.projects', url: '#projects' },
  { title: 'sections.talks', url: '#talks' },
  { title: 'sections.contact', url: '#contact' },
];

const onNavigation = () => {
  mixpanel.track('Navigation');
};
</script>

<style lang="scss" scoped>
@use '@/styles/mixins';
@use '@/styles/screens';

.hero__subtitle {
  @include mixins.monotext;
}

.hero__title {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-size: 54px;
  font-style: italic;
  font-weight: 400;
  margin: 32px 0 64px;

  @include screens.tablet {
    font-size: var(--font-size-hero);
  }
}

.hero__description {
  font-size: 18px;
  max-width: 680px;

  @include screens.tablet {
    font-size: 24px;
  }
}

.hero__nav {
  display: none;
  margin: 32px 0 24px;
  
  @include screens.tablet {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }
}

.hero__navitem {
  display: inline-block;
}

.hero__link {
  @include mixins.monotext(true);
}
</style>
